import React from 'react'
import { FormInputSelectAndNavigate } from '../../../../../../../ui/organisms'

export default {
  title: 'Can you tell us what type of residential project this is?',
  next: 'projectInfo.projectRole',
  component: (props) => <FormInputSelectAndNavigate options={[
    'New construction single family unit',
    'Remodeling single family unit',
    'New construction multi-family units',
    'Remodeling multi-family units'
  ]} {...props}/>
}